<div class="input-group">
  <input class="form-control" [(ngModel)]="display" readonly placeholder="{{'weekpicker.placeholder'|translate}}" (click)="d.toggle()">
  <input class="datepicker" type="text"
         name="dp"
         ngbDatepicker
         [dayTemplate]="day"
         firstDayOfWeek = 7
         [minDate]="minMaxRange.fromDate"
         [maxDate]="minMaxRange.toDate"
         (dateSelect)="onDateSelection($event)"
         #d="ngbDatepicker">
  <ng-template #day let-date let-focused="focused">
        <span class="btn-light"
              [class.focused]="focused"
              [class.range]="isCurrentRange(date)"
              [class.hover]="isHovered(date)"
              [class.faded]="isInsideCurrent(date)"
              (mouseenter)="onHover(date)"
              (mouseleave)="hoveredDate = null">
          {{ date.day }}
        </span>
  </ng-template>
  <div class="input-group-append">
    <button class="btn btn-outline-secondary cal" (click)="d.toggle()" type="button" pTooltip="{{'weekpicker.placeholder'|translate}}" tooltipPosition="right">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="-4 -2 40 40"><path d="M7.111 16h3.556v3.556h-3.556v-3.556z"></path><path d="M7.111 21.333h3.556v3.556h-3.556v-3.556z"></path><path d="M28.444 1.778h-5.333v-1.778h-3.556v1.778h-7.111v-1.778h-3.556v1.778h-5.333c-1.964 0-3.556 1.592-3.556 3.556v0 23.111c0 1.964 1.592 3.556 3.556 3.556v0h24.889c1.964 0 3.556-1.592 3.556-3.556v0-23.111c0-1.964-1.592-3.556-3.556-3.556v0zM28.444 28.444h-24.889v-16h24.889zM28.444 8.889h-24.889v-3.556h5.333v1.778h3.556v-1.778h7.111v1.778h3.556v-1.778h5.333z"></path><path d="M14.222 16h3.556v3.556h-3.556v-3.556z"></path><path d="M14.222 21.333h3.556v3.556h-3.556v-3.556z"></path><path d="M21.333 16h3.556v3.556h-3.556v-3.556z"></path><path d="M21.333 21.333h3.556v3.556h-3.556v-3.556z"></path>
      </svg>
    </button>
  </div>
</div>
